import { render, staticRenderFns } from "./we-vendor.vue?vue&type=template&id=9dce0054"
import script from "./we-vendor.vue?vue&type=script&lang=js"
export * from "./we-vendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports